import React, { useEffect, useState } from "react";
import { fetchJson } from "../api";

const GOLD = "#d4a550";
const GOLD_DIM = "rgba(212,165,80,0.15)";
const GOLD_BORDER = "rgba(212,165,80,0.35)";
const BG = "#0a0a0f";
const SURFACE = "#12121a";
const BORDER = "rgba(255,255,255,0.07)";
const TEXT = "#e8e6df";
const TEXT_DIM = "rgba(232,230,223,0.45)";

function Avatar({ nome, cognome, url, size = 32 }) {
  const initials = ((nome||"")[0]||"") + ((cognome||"")[0]||"");
  if (url) return <img src={url} alt={initials} style={{width:size,height:size,borderRadius:"50%",objectFit:"cover",flexShrink:0}} />;
  return <div style={{width:size,height:size,borderRadius:"50%",background:GOLD_DIM,border:"1px solid "+GOLD_BORDER,display:"flex",alignItems:"center",justifyContent:"center",fontSize:size*0.35,fontWeight:700,color:GOLD,flexShrink:0}}>{initials||"?"}</div>;
}

export default function SquadrePage() {
  const [productions, setProductions] = useState([]);
  const [selectedProd, setSelectedProd] = useState(null);
  const [rosa, setRosa] = useState([]);
  const [freelancers, setFreelancers] = useState([]);
  const [q, setQ] = useState("");
  const [roleFilter, setRoleFilter] = useState("");
  const [ruoli, setRuoli] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataInizio, setDataInizio] = useState("");
  const [salvato, setSalvato] = useState(false);
  const [pageH, setPageH] = useState(window.innerHeight - 56);
  useEffect(() => {
    const onResize = () => setPageH(window.innerHeight - 56);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    fetchJson("/productions").then(d => setProductions(d.productions || d || [])).catch(()=>{});
    fetchJson("/postplans/freelancers/roles").then(d => setRuoli(d.roles || [])).catch(()=>{});
  }, []);

  useEffect(() => {
    if (!selectedProd) { setRosa([]); return; }
    fetchJson("/postplans/rosa/" + selectedProd.id)
      .then(d => {
        const items = (d.rosa || []).map(r => ({
          id: r.freelancer_id ? r.freelancer_id : ("m_" + r.id),
          freelancer_id: r.freelancer_id || null,
          nome: r.nome || r.name_override || "",
          cognome: r.cognome || "",
          profile_image_url: r.profile_image_url || null,
          avatar_url: r.avatar_url || null,
          ruoli: r.ruoli || (r.ruolo ? [r.ruolo] : []),
          name_override: r.name_override || null,
          isJkl: !!r.freelancer_id,
        }));
        setRosa(items);
      })
      .catch(() => {});
  }, [selectedProd]);

  useEffect(() => {
    if (!selectedProd) return;
    setLoading(true);
    const t = setTimeout(() => {
      fetchJson("/postplans/freelancers/search?q=" + encodeURIComponent(q) + "&role=" + encodeURIComponent(roleFilter) + "&from=" + encodeURIComponent(dataInizio))
        .then(d => { setFreelancers(d.freelancers || []); setLoading(false); })
        .catch(() => setLoading(false));
    }, 300);
    return () => clearTimeout(t);
  }, [q, roleFilter, selectedProd, dataInizio]);

  function toggle(f) {
    if (rosa.find(p => p.id === f.id)) setRosa(r => r.filter(p => p.id !== f.id));
    else setRosa(r => [...r, f]);
  }

  const inRosa = id => rosa.some(p => p.id === id);

  async function salvaRosa() {
    if (!selectedProd) return;
    setSalvato(false);
    try {
      const items = rosa.map(p => ({
        freelancerId: p.freelancer_id || null,
        nameOverride: p.name_override || (p.nome + " " + p.cognome).trim() || null,
        ruolo: (p.ruoli || [])[0] || null,
      }));
      await fetchJson("/postplans/rosa/" + selectedProd.id, {
        method: "POST",
        body: JSON.stringify({ items }),
      });
      setSalvato(true);
      setTimeout(() => setSalvato(false), 2000);
    } catch (e) {
      alert("Errore salvataggio: " + e.message);
    }
  }

  const byRole = {};
  rosa.forEach(p => { const r = (p.ruoli||[])[0]||"Altro"; if (!byRole[r]) byRole[r]=[]; byRole[r].push(p); });

  const btnStyle = (active) => ({
    padding:"3px 8px", borderRadius:12, fontSize:11, fontWeight:600, cursor:"pointer",
    border:"1px solid " + (active ? GOLD_BORDER : BORDER),
    background: active ? GOLD_DIM : "transparent",
    color: active ? GOLD : TEXT_DIM
  });

  return (
    <div style={{height:"calc(100vh - 56px)",background:BG,color:TEXT,fontFamily:"'Kanit','Inter',sans-serif",overflow:"hidden"}}>
      <div style={{padding:"20px 24px",borderBottom:"1px solid "+BORDER,background:SURFACE}}>
        <h1 style={{margin:0,fontSize:18,fontWeight:700}}>Squadre</h1>
        <p style={{margin:"4px 0 0",fontSize:12,color:TEXT_DIM}}>Costruisci la rosa per le tue produzioni</p>
      </div>

      <div style={{display:"flex",height:"calc(100% - 73px)"}}>
        <div style={{flex:1,display:"flex",flexDirection:"column",borderRight:"1px solid "+BORDER,overflow:"hidden"}}>
          <div style={{padding:"16px 20px",borderBottom:"1px solid "+BORDER}}>
            <div style={{display:"flex",gap:16,alignItems:"flex-end"}}>
              <div style={{flex:2}}>
              <div style={{fontSize:11,fontWeight:600,color:TEXT_DIM,letterSpacing:"0.06em",textTransform:"uppercase",marginBottom:8}}>Produzione</div>
            <select value={selectedProd?.id||""} onChange={e => setSelectedProd(productions.find(x=>String(x.id)===e.target.value)||null)}
              style={{width:"100%",background:SURFACE,border:"1px solid "+BORDER,borderRadius:6,color:TEXT,fontSize:13,padding:"8px 10px",colorScheme:"dark"}}>
              <option value="">Seleziona una produzione…</option>
              {productions.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:11,fontWeight:600,color:TEXT_DIM,letterSpacing:"0.06em",textTransform:"uppercase",marginBottom:8}}>Inizio post</div>
              <input type="date" value={dataInizio} onChange={e=>setDataInizio(e.target.value)}
                style={{width:"100%",boxSizing:"border-box",background:"rgba(255,255,255,0.04)",border:"1px solid "+BORDER,borderRadius:6,color:TEXT,fontSize:13,padding:"8px 10px"}} />
            </div>
            </div>
          </div>

          {selectedProd && <>
            <div style={{padding:"12px 20px",borderBottom:"1px solid "+BORDER,display:"flex",flexDirection:"column",gap:8}}>
              <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Cerca per nome…"
                style={{background:"rgba(255,255,255,0.04)",border:"1px solid "+BORDER,borderRadius:6,color:TEXT,fontSize:13,padding:"7px 10px",outline:"none"}} />
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                <button onClick={()=>setRoleFilter("")} style={btnStyle(!roleFilter)}>Tutti</button>
          {[...(ruoli.some(r=>r.startsWith('Editor Video'))?['Editor Video']:[]),...ruoli.filter(r=>!r.startsWith('Editor Video'))].sort((a,b)=>a.localeCompare(b,'it')).map(r=><button key={r} onClick={()=>setRoleFilter(roleFilter===r?'':r)} style={btnStyle(roleFilter===r)}>{r==='Editor Video'?'Editor Video (tutti)':r}</button>)}
              </div>
            </div>
            <div style={{overflowY:"auto",flex:1}}>
              {loading && <div style={{padding:20,textAlign:"center",color:TEXT_DIM,fontSize:12}}>Ricerca…</div>}
              {!loading && freelancers.map(f => {
                const added = inRosa(f.id);
                return (
                  <div key={f.id} style={{padding:"10px 20px",display:"flex",alignItems:"center",gap:12,borderBottom:"1px solid "+BORDER,background:added?"rgba(212,165,80,0.04)":"transparent"}}>
                    <Avatar nome={f.nome} cognome={f.cognome} url={f.profile_image_url||f.avatar_url} />
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:13,fontWeight:600,color:TEXT}}>{f.nome} {f.cognome}</div>
                      {f.ruoli?.length>0 && <div style={{fontSize:11,color:TEXT_DIM,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{f.ruoli.slice(0,3).join(" · ")}</div>}
                    </div>
                    {dataInizio && (
                      <span style={{fontSize:10,fontWeight:600,padding:"2px 7px",borderRadius:10,flexShrink:0,
                        background: f.availability==="free" ? "rgba(74,222,128,0.12)" : f.availability==="soon" ? "rgba(251,191,36,0.12)" : "rgba(239,68,68,0.10)",
                        border: "1px solid " + (f.availability==="free" ? "rgba(74,222,128,0.4)" : f.availability==="soon" ? "rgba(251,191,36,0.4)" : "rgba(239,68,68,0.3)"),
                        color: f.availability==="free" ? "#4ade80" : f.availability==="soon" ? "#fbbf24" : "#f87171"
                      }}>
                        {f.availability==="free" ? "Libero" : f.availability==="soon" ? ("Lib. "+new Date(f.free_from).toLocaleDateString("it-IT",{day:"2-digit",month:"2-digit"})) : "Occupato"}
                      </span>
                    )}
                    <span style={{fontSize:10,color:GOLD,border:"1px solid "+GOLD_BORDER,borderRadius:4,padding:"1px 5px",flexShrink:0}}>◈ JKL</span>
                    <button onClick={()=>toggle(f)} style={{padding:"5px 12px",borderRadius:6,fontSize:11,fontWeight:600,cursor:"pointer",flexShrink:0,border:"1px solid "+(added?GOLD_BORDER:BORDER),background:added?GOLD_DIM:"rgba(255,255,255,0.04)",color:added?GOLD:TEXT_DIM}}>
                      {added?"✓ In rosa":"+ Opziona"}
                    </button>
                  </div>
                );
              })}
              {!loading && freelancers.length===0 && <div style={{padding:24,textAlign:"center",color:TEXT_DIM,fontSize:13}}>Nessun freelance trovato</div>}
            </div>
          </>}
          {!selectedProd && <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",color:TEXT_DIM,fontSize:13}}>Seleziona una produzione per iniziare</div>}
        </div>

        <div style={{width:360,display:"flex",flexDirection:"column",background:SURFACE}}>
          <div style={{padding:"16px 20px",borderBottom:"1px solid "+BORDER,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <div style={{fontSize:14,fontWeight:700,color:GOLD}}>Rosa{selectedProd?" — "+selectedProd.name:""}</div>
            <div style={{fontSize:12,color:TEXT_DIM}}>{rosa.length} persone</div>
          </div>
          {rosa.length>0 && (
            <div style={{padding:"8px 16px",borderBottom:"1px solid "+BORDER,display:"flex",gap:6,flexWrap:"wrap"}}>
              {Object.entries(byRole).map(([r,ps])=>(
                <span key={r} style={{fontSize:10,color:GOLD,border:"1px solid "+GOLD_BORDER,borderRadius:10,padding:"2px 8px"}}>{r.split(" ")[0]}: {ps.length}</span>
              ))}
            </div>
          )}
          <div style={{overflowY:"auto",flex:1}}>
            {rosa.length===0 ? (
              <div style={{padding:24,textAlign:"center",color:TEXT_DIM,fontSize:13}}>Nessuna persona opzionata.<br/>Cerca e aggiungi dalla lista.</div>
            ) : (
              Object.entries(byRole).map(([role, persons]) => (
                <div key={role} style={{borderBottom:"1px solid "+BORDER}}>
                  <div style={{padding:"10px 16px 6px",fontSize:11,fontWeight:600,color:TEXT_DIM,letterSpacing:"0.06em",textTransform:"uppercase",display:"flex",justifyContent:"space-between"}}>
                    <span>{role}</span>
                    <span style={{color:GOLD,fontSize:10,border:"1px solid "+GOLD_BORDER,borderRadius:10,padding:"1px 7px"}}>{persons.length}</span>
                  </div>
                  {persons.map(p => (
                    <div key={p.id} style={{padding:"6px 16px",display:"flex",alignItems:"center",gap:10}}>
                      <Avatar nome={p.nome} cognome={p.cognome} url={p.profile_image_url||p.avatar_url} size={26} />
                      <span style={{flex:1,fontSize:13,color:TEXT}}>{p.nome} {p.cognome}</span>
                      <span style={{fontSize:10,color:GOLD,border:"1px solid "+GOLD_BORDER,borderRadius:4,padding:"1px 5px"}}>◈ JKL</span>
                      <button onClick={()=>toggle(p)} style={{background:"none",border:"none",color:"rgba(239,68,68,0.5)",cursor:"pointer",fontSize:14,padding:"0 4px"}}>×</button>
                    </div>
                  ))}
                </div>
              ))
            )}
          </div>
          {selectedProd && rosa.length>0 && (
            <div style={{padding:"12px 16px",borderTop:"1px solid "+BORDER}}>
              <button onClick={salvaRosa}
                style={{width:"100%",background:salvato?"rgba(34,197,94,0.15)":GOLD_DIM,border:"1px solid "+(salvato?"rgba(34,197,94,0.4)":GOLD_BORDER),borderRadius:6,color:salvato?"#4ade80":GOLD,fontSize:13,fontWeight:600,padding:"9px",cursor:"pointer",transition:"all 0.3s"}}>
                {salvato ? "✓ Rosa salvata!" : "Salva rosa per "+selectedProd.name}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
